// extracted by mini-css-extract-plugin
module.exports = {"tabs":"AccountTabs_tabs__l8Ehk","tab":"AccountTabs_tab__8nU45","activeTab":"AccountTabs_activeTab__n_6P2"};